import { useState } from "react";
import styled from "styled-components";
import MayoLogo from "../../tenants/mayo/patientFacing/common/MayoLogo";
import MayoVideoHeader from "../../tenants/mayo/patientFacing/common/MayoVideoHeader";

import videoThumbnail from "../../assets/Mayo/thumbnail1.jpg";
import bgImg from "../../assets/Mayo/bg_1_for_videe_pages.svg"
import { useSearchParams } from "react-router-dom";

import AppointmentsPopUp from "../../tenants/mayo/patientFacing/mayo1/AppointmentsPopUp";
import { useEffect } from "react";
import { AVATAR_OPTIONS } from "../../tenants/mayo/patientFacing/mayo1/MayoChooseAvatar";

export default function DemoPatientVideo() {
  const [ avatarImage, setAvatarImage] = useState(null);
  const [showAppointments, setShowAppointments] = useState(false);

  const [searchParams] = useSearchParams();

  const closePopUp = () => {
    setShowAppointments(false);
  }

  const loadAvatarImage = ({age, gender, ethnicity}) => {
    if(!age || !gender || !ethnicity) return;

    const avatar = AVATAR_OPTIONS.filter(avatar => 
      avatar?.ageAvatarVal === age &&
      avatar?.sex.toLowerCase() === gender &&
      avatar?.ethnicity === ethnicity
    )
    setAvatarImage(avatar?.[0]?.image || "avatar image not found");
  }

  useEffect(() => {
    const avatarData = JSON.parse(searchParams.get("data")) || {};
    loadAvatarImage(avatarData);
  }, []);

  return (
    <Container>
      { showAppointments &&
        <AppointmentsPopUp onCancle={closePopUp} />
      }

      <MayoLogo />
      <MayoVideoHeader 
        postAnalyticType={""}
        title={"Watch the demo to experience the TAVR patient education solution developed in collaboration with Mayo Clinic"}
        videoThumbnail={videoThumbnail}
        altProjectName={"The Power of Personalization"}
        altAge={"young"}
      />
      <HL />
      {avatarImage &&
        <Avatar 
          src={avatarImage}
        />
      }
    </Container>
  );
}


const Container = styled.div`
  font-family: Abraham;
  min-height: 100vh;
  background-image: url("${bgImg}");
  background-repeat: repeat;
  background-size: cover;
  background-position: center;
`

const HL = styled.div`
  background-color: #CCD9FB;
  height: 1px;
  margin-inline: 26px;
`

const Avatar = styled.img`
  display: block;
  border-radius: 50%;
  width: 100px;
  height: 100px;

  margin-top: 24px;
  margin-left: 23px;
`

const ShowAllAppointmentsText = styled.p`
  margin: 0;
  margin-top: 18px;
  margin-left: 26px;
  margin-bottom: 36px;;

  color: #81A0F6;
  font-size: 19px;
  font-weight: 500;
  text-decoration: underline;
`
